export default "__VITE_ASSET__BbMr67pC__"